/*
 * sp-rsl-cart-ajax.js — Ouvre le TIROIR panier à chaque ajout pour les buy-box custom
 * (formulaires `/cart/add` bruts : offer, offer-pro, offer-creme, offer-led, cross, bundle…).
 * Objectif : le client VOIT son panier (produits + quantité ajustable + suppression) au lieu
 * d'être redirigé vers /cart ou pire vers /checkout. Repli sûr : si pas de tiroir ou erreur
 * réseau, on retombe sur le comportement normal (page /cart).
 *
 * - Écoute `submit` en bubbling : si une section gère déjà l'ajout (e.preventDefault déjà appelé,
 *   ex. bundle multi-items), on NE double-ajoute PAS.
 * - Expose window.spRslOpenCartDrawer() pour les sections qui font leur propre fetch (bundle).
 */
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function drawer() { return document.querySelector('cart-drawer'); }

  function isRawCartForm(f) {
    return f && f.tagName === 'FORM'
      && (f.getAttribute('action') || '').indexOf('/cart/add') !== -1
      && !f.closest('product-form'); // les <product-form> Dawn se gèrent seuls
  }

  // Ré-affiche le tiroir depuis une réponse contenant .sections puis l'ouvre.
  function renderDrawer(data) {
    var d = drawer();
    if (!d || !d.renderContents) { window.location = ROOT + 'cart'; return; }
    d.classList.remove('is-empty');
    d.renderContents(data);
  }

  // Pour un ajout déjà effectué ailleurs (ex. bundle) : on va chercher les sections puis on ouvre.
  window.spRslOpenCartDrawer = function () {
    if (!drawer()) { window.location = ROOT + 'cart'; return; }
    fetch(ROOT + '?sections=cart-drawer,cart-icon-bubble', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) { renderDrawer({ sections: sections }); })
      .catch(function () { window.location = ROOT + 'cart'; });
  };

  function ajaxAdd(form) {
    if (!drawer()) { form.submit(); return; }
    var btns = form.querySelectorAll('[type="submit"]');
    btns.forEach(function (b) { b.disabled = true; b.classList.add('loading'); b.setAttribute('aria-busy', 'true'); });

    var fd = new FormData(form);
    fd.delete('return_to'); // ne PAS sauter le panier
    fd.append('sections', 'cart-drawer,cart-icon-bubble');
    fd.append('sections_url', window.location.pathname);

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) { window.location = ROOT + 'cart'; return; } // rupture de stock, etc.
        renderDrawer(data);
      })
      .catch(function () { window.location = ROOT + 'cart'; })
      .finally(function () {
        btns.forEach(function (b) { b.disabled = false; b.classList.remove('loading'); b.removeAttribute('aria-busy'); });
      });
  }

  document.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return;         // une section gère déjà cet ajout
    var form = e.target;
    if (!isRawCartForm(form)) return;
    if (!drawer()) return;                  // pas de tiroir -> submit natif (page /cart)
    e.preventDefault();
    ajaxAdd(form);
  }, false);
})();
